import {
  Title as DefaultTitle,
  Small as DefaultSmall,
  Modal as DefaultModal,
} from '@getinapp/appetizer';
import styled, { css } from 'styled-components';

export const Title = styled(DefaultTitle)`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large} !important;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
    margin-bottom: 3rem;
  `}
`;

export const Small = styled(DefaultSmall)`
  ${({ theme }) => css`
    small {
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`;

export const Modal = styled(DefaultModal)`
  background: white;

  button {
    ${({ theme }) => css`
      color: ${theme.colors.white};
    `}
  }

  input {
    width: 4.15rem !important;
    -moz-appearance: textfield !important;
    -webkit-appearance: none !important;
    padding-left: 1.2rem !important;
    ${({ theme }) => css`
      font-family: ${theme.font.family} !important;
      font-size: ${theme.font.sizes.xlarge} !important;
      font-weight: bold;
    `}
  }
`;

export const BackButton = styled.p`
  margin-top: 1.5rem;
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;

    &:hover {
      cursor: pointer;
    }
    span {
      margin-right: 1rem;
    }
  `}
`;

export const CountdownParagraph = styled.p<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    color: ${theme.colors.primary};
    font-size: 1.5rem;
    text-align: center;
    margin: 1.5rem 0;
    cursor: pointer;

    ${disabled &&
    css`
      color: ${theme.colors.highContrast};
      cursor: default;
    `}
  `}
`;
